import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { Decimal, NoValue } from '~/modules/common/components';

const formatValueWithUnit = (value, unit) => {
  if (value == null) return <NoValue />;

  return (
    <Decimal
      value={value}
      suffix={` ${unit}`}
      fixedDecimalScale
      precision={2}
    />
  );
};

const PeriodBlockTooltip = memo(
  ({ period, bench, overAllocation, unitLabel }) => {
    const overAllocationValues = useMemo(
      () => ({ value: formatValueWithUnit(overAllocation, unitLabel) }),
      [overAllocation, unitLabel]
    );

    const benchValues = useMemo(
      () => ({ value: formatValueWithUnit(bench, unitLabel) }),
      [bench, unitLabel]
    );

    return (
      <>
        <Typography variant="caption" display="block">
          {period}
        </Typography>
        <Typography variant="caption" display="block">
          <FormattedMessage
            id="resourceManagementDashboard.benchOverAllocationTracker.overAllocatedTooltipValue"
            values={overAllocationValues}
          />
        </Typography>
        <Typography variant="caption" display="block">
          <FormattedMessage
            id="resourceManagementDashboard.benchOverAllocationTracker.benchTooltipValue"
            values={benchValues}
          />
        </Typography>
      </>
    );
  }
);

PeriodBlockTooltip.propTypes = {
  period: PropTypes.string.isRequired,
  bench: PropTypes.number,
  overAllocation: PropTypes.number,
  unitLabel: PropTypes.string.isRequired
};

export default PeriodBlockTooltip;
